/*
 * @file: index.js
 * @description: It Contain environment variables.
 * @author: faisal,
 */

//PRODUCTION
const production = {
    apiUrl: 'https://api.glendaleca.gov/api/v1/admin',
    apiUrlMerchant: 'https://api.glendaleca.gov/api/v1/merchant',
    apiUrlMerchantItems: 'https://api.glendaleca.gov/api/v1/items',
    apiUrlhive: 'https://api.glendaleca.gov/api/v1/wallet',
    apiUrlemssion: 'https://api.glendaleca.gov/api/v1/emission',
    apiUrlSchool: "https://api.glendaleca.gov/api/v1/school",
    apiUrlVehicle: "https://api.glendaleca.gov/api/v1/vehicle",
    apiUrlBase: "https://api.glendaleca.gov/api/v1",
    file: '',
}

//QA
const qa = {
    apiUrl: 'https://qa-api.glendaleca.gov/api/v1/admin',
    apiUrlMerchant: 'https://qa-api.glendaleca.gov/api/v1/merchant',
    apiUrlMerchantItems: 'https://qa-api.glendaleca.gov/api/v1/items',
    apiUrlhive: 'https://qa-api.glendaleca.gov/api/v1/wallet',
    apiUrlemssion: 'https://qa-api.glendaleca.gov/api/v1/emission',
    apiUrlSchool: "https://qa-api.glendaleca.gov/api/v1/school",
    apiUrlVehicle: "https://qa-api.glendaleca.gov/api/v1/vehicle",
    apiUrlBase: "https://qa-api.glendaleca.gov/api/v1",
    file: '',
}

//DEVELOPMENT
const development = {
    apiUrl: 'https://cityofglendale-api.mobileprogramming.net/api/v1/admin',
    apiUrlMerchant: 'https://cityofglendale-api.mobileprogramming.net/api/v1/merchant',
    apiUrlMerchantItems: 'https://cityofglendale-api.mobileprogramming.net/api/v1/items',
    apiUrlhive: 'https://cityofglendale-api.mobileprogramming.net/api/v1/wallet',
    apiUrlemssion: 'https://cityofglendale-api.mobileprogramming.net/api/v1/emission',
    apiUrlSchool: "https://cityofglendale-api.mobileprogramming.net/api/v1/school",
    apiUrlVehicle: "https://cityofglendale-api.mobileprogramming.net/api/v1/vehicle",
    apiUrlBase: "https://cityofglendale-api.mobileprogramming.net/api/v1",
    file: '',
}

//LOCAL
// const local = {
//     apiUrl: 'https://cityofglendale-api.mobileprogramming.net/api/v1/admin',
//     apiUrlMerchant: 'https://cityofglendale-api.mobileprogramming.net/api/v1/merchant',
//     apiUrlMerchantItems: 'https://cityofglendale-api.mobileprogramming.net/api/v1/items',
//     apiUrlhive: 'https://cityofglendale-api.mobileprogramming.net/api/v1/wallet',
//     apiUrlemssion: 'https://cityofglendale-api.mobileprogramming.net/api/v1/emission',
//     apiUrlSchool: "https://cityofglendale-api.mobileprogramming.net/api/v1/school",
//     apiUrlVehicle: "https://cityofglendale-api.mobileprogramming.net/api/v1/vehicle",
//     apiUrlBase: "https://cityofglendale-api.mobileprogramming.net/api/v1",
//     file: '',
// }

module.exports = production

// if (window.location.hostname === 'webadmin.glendaleca.gov') {
//     module.exports = production
// }
// if (window.location.hostname === 'qa-webadmin.glendaleca.gov') {
//     module.exports = qa
// }
// else {
//     module.exports = development
// }
